
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("V5Yjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6731d35f47ac14ce$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f5CSo = parcelRequire("f5CSo");

var $VSDnB = parcelRequire("VSDnB");

var $l4haf = parcelRequire("l4haf");
var $6731d35f47ac14ce$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)(function MentionItem(props) {
    const { eventHandlers: eventHandlers, id: id, providers: providers, text: text, accessLevel: accessLevel, localId: localId } = props;
    const inlineAnnotationProps = (0, $l4haf.useInlineAnnotationProps)(props);
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...inlineAnnotationProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f5CSo.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            providers: providers,
            localId: localId,
            eventHandlers: eventHandlers && eventHandlers.mention
        })
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f5CSo.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        providers: providers,
        localId: localId,
        eventHandlers: eventHandlers && eventHandlers.mention
    });
});

});
parcelRegister("f5CSo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fccadb1619106cb$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dGzaM = parcelRequire("dGzaM");
var $9Egzu = parcelRequire("9Egzu");

var $bqClF = parcelRequire("bqClF");
class $3fccadb1619106cb$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), this.renderWithProvider = (providers)=>{
            const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, text: text, localId: localId } = this.props;
            const { mentionProvider: mentionProvider, profilecardProvider: profilecardProvider } = providers;
            if ((0, $VSDnB.fg)('platform_editor_react18_mention_with_provider_fix') || (0, $VSDnB.fg)('platform_editor_react18_mention_with_provider_jira')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bqClF.MentionWithProviders), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                eventHandlers: eventHandlers,
                mentionProvider: mentionProvider,
                profilecardProvider: profilecardProvider
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bqClF.MentionWithProvidersOld), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                eventHandlers: eventHandlers,
                mentionProvider: mentionProvider,
                profilecardProvider: profilecardProvider
            });
        };
        this.providerFactory = props.providers || new (0, $dGzaM.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Egzu.WithProviders), {
            providers: [
                'mentionProvider',
                'profilecardProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}

});
parcelRegister("bqClF", function(module, exports) {

$parcel$export(module.exports, "MentionWithProviders", () => $bd15e70c2ae654b6$export$cd21803c89efe790);
$parcel$export(module.exports, "MentionWithProvidersOld", () => $bd15e70c2ae654b6$export$7279f5a9685c37e0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kmW28 = parcelRequire("kmW28");

var $b6FQr = parcelRequire("b6FQr");
const $bd15e70c2ae654b6$var$GENERIC_USER_IDS = [
    'HipChat',
    'all',
    'here'
];
const $bd15e70c2ae654b6$var$noop = ()=>{};
const $bd15e70c2ae654b6$export$cd21803c89efe790 = ({ accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderResolver, text: text, localId: localId })=>{
    const [profilecardProvider, setProfilecardProvider] = (0, $5uXOq.useState)(null);
    const mountedRef = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        profilecardProviderResolver?.then((result)=>{
            if (mountedRef.current) setProfilecardProvider(result);
        }).catch(()=>{
            if (mountedRef.current) setProfilecardProvider(null);
        });
    }, [
        profilecardProviderResolver
    ]);
    const MentionComponent = profilecardProvider && profilecardProviderResolver && $bd15e70c2ae654b6$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $b6FQr.default) : (0, $kmW28.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(MentionComponent, {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        mentionProvider: mentionProvider,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        profilecardProvider: profilecardProvider,
        onClick: eventHandlers?.onClick,
        onMouseEnter: eventHandlers?.onMouseEnter,
        onMouseLeave: eventHandlers?.onMouseLeave
    });
};
class $bd15e70c2ae654b6$export$7279f5a9685c37e0 extends (0, $5uXOq.PureComponent) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillMount() {
        this.updateProfilecardProvider(this.props);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.profilecardProvider !== this.props.profilecardProvider) this.updateProfilecardProvider(nextProps);
    }
    updateProfilecardProvider(props) {
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        if (props.profilecardProvider) props.profilecardProvider.then((profilecardProvider)=>{
            this.setState({
                profilecardProvider: profilecardProvider
            });
        }).catch(()=>{
            this.setState({
                profilecardProvider: null
            });
        });
        else this.setState({
            profilecardProvider: null
        });
    }
    render() {
        const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, mentionProvider: mentionProvider, text: text, localId: localId } = this.props;
        const { profilecardProvider: profilecardProvider } = this.state;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const actionHandlers = {};
        [
            'onClick',
            'onMouseEnter',
            'onMouseLeave'
        ].forEach((handler)=>{
            actionHandlers[handler] = eventHandlers && eventHandlers[handler] || $bd15e70c2ae654b6$var$noop;
        });
        const MentionComponent = profilecardProvider && $bd15e70c2ae654b6$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $b6FQr.default) : (0, $kmW28.default);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(MentionComponent, {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            mentionProvider: mentionProvider,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            profilecardProvider: profilecardProvider,
            ...actionHandlers
        });
    }
    constructor(...args){
        super(...args), this.state = {
            profilecardProvider: null
        };
    }
}

});
parcelRegister("kmW28", function(module, exports) {

$parcel$export(module.exports, "default", () => $e858e38a821330f3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3mm6g = parcelRequire("3mm6g");

var $cqJWb = parcelRequire("cqJWb");

var $8dw1i = parcelRequire("8dw1i");

var $6Ctoj = parcelRequire("6Ctoj");
class $e858e38a821330f3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    constructor(props){
        super(props), this.handleMentionProvider = (props)=>{
            const { id: id, mentionProvider: mentionProvider, text: text } = props;
            if (mentionProvider) mentionProvider.then((provider)=>{
                const newState = {
                    isHighlighted: provider.shouldHighlightMention({
                        id: id
                    })
                };
                if (!text && (0, $3mm6g.isResolvingMentionProvider)(provider)) {
                    const nameDetail = provider.resolveMentionName(id);
                    if ((0, $cqJWb.isPromise)(nameDetail)) nameDetail.then((nameDetailResult)=>{
                        this.setStateSafely({
                            resolvedMentionName: this.processName(nameDetailResult)
                        });
                    });
                    else newState.resolvedMentionName = this.processName(nameDetail);
                }
                this.setStateSafely(newState);
            }).catch(()=>{
                this.setStateSafely({
                    isHighlighted: false
                });
            });
            else this.setStateSafely({
                isHighlighted: false
            });
        };
        this._isMounted = false;
        this.state = {
            isHighlighted: false
        };
    }
    componentDidMount() {
        this.handleMentionProvider(this.props);
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { props: props } = this;
        if (props.id !== nextProps.id || props.mentionProvider !== nextProps.mentionProvider) this.handleMentionProvider(nextProps);
    }
    setStateSafely(newState) {
        if (!this._isMounted) {
            (0, $6Ctoj.default)('[ResourcedMention]: cannot setState when component is unmounted.');
            return;
        }
        this.setState(newState);
    }
    processName(name) {
        let mentionName;
        switch(name.status){
            case (0, $cqJWb.MentionNameStatus).OK:
                mentionName = name.name || '';
                break;
            case (0, $cqJWb.MentionNameStatus).SERVICE_ERROR:
            case (0, $cqJWb.MentionNameStatus).UNKNOWN:
            default:
                mentionName = (0, $8dw1i.UNKNOWN_USER_ID);
                break;
        }
        return `@${mentionName}`;
    }
    render() {
        const { props: props, state: state } = this;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8dw1i.default), {
            id: props.id,
            text: props.text || state.resolvedMentionName || '',
            isHighlighted: state.isHighlighted,
            accessLevel: props.accessLevel,
            localId: props.localId,
            onClick: props.onClick,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave
        });
    }
}

});
parcelRegister("3mm6g", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionResource", () => $9565842f98e50876$export$8576ba1ed2760927);
$parcel$export(module.exports, "isResolvingMentionProvider", () => $9565842f98e50876$export$ae1fce5f69858ef3);

var $dS9cn = parcelRequire("dS9cn");

var $cqJWb = parcelRequire("cqJWb");

var $6Ctoj = parcelRequire("6Ctoj");

var $4kfbr = parcelRequire("4kfbr");

var $lFKmC = parcelRequire("lFKmC");
const $9565842f98e50876$var$MAX_QUERY_ITEMS = 100;
const $9565842f98e50876$var$MAX_NOTIFIED_ITEMS = 20;
const $9565842f98e50876$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $9565842f98e50876$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}
class $9565842f98e50876$export$8576ba1ed2760927 extends $9565842f98e50876$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $6Ctoj.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $9565842f98e50876$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $6Ctoj.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $9565842f98e50876$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $9565842f98e50876$export$5a4331e3e1c43553 extends $9565842f98e50876$export$8576ba1ed2760927 {
    constructor(config){
        super();
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(this.filter, this.config.debounceTime);
    }
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $6Ctoj.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $cqJWb.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $9565842f98e50876$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
	 * Clear a context object to generate query params by removing empty
	 * strings, `undefined` and empty values.
	 *
	 * @param contextIdentifier the current context identifier
	 * @returns a safe context for query encoding
	 */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
	 * Returns the initial mention display list before a search is performed for the specified
	 * container.
	 *
	 * @param contextIdentifier
	 * @returns Promise
	 */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $dS9cn.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).INITIAL_STATE, (0, $cqJWb.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).INITIAL_STATE, (0, $cqJWb.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $9565842f98e50876$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $dS9cn.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).SEARCH, (0, $cqJWb.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).SEARCH, (0, $cqJWb.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $cqJWb.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $cqJWb.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
}
class $9565842f98e50876$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $9565842f98e50876$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $9565842f98e50876$export$2e2bcd8739ae039 = $9565842f98e50876$export$5a4331e3e1c43553;

});
parcelRegister("cqJWb", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $90ca79fb430b6e09$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $90ca79fb430b6e09$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $90ca79fb430b6e09$export$8436e53e45ffe15b);
$parcel$export(module.exports, "SliNames", () => $90ca79fb430b6e09$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "ComponentNames", () => $90ca79fb430b6e09$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "Actions", () => $90ca79fb430b6e09$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "MentionNameStatus", () => $90ca79fb430b6e09$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $90ca79fb430b6e09$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $90ca79fb430b6e09$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $90ca79fb430b6e09$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $90ca79fb430b6e09$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $90ca79fb430b6e09$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $90ca79fb430b6e09$export$4369c812aac99591);
var $90ca79fb430b6e09$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $90ca79fb430b6e09$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $90ca79fb430b6e09$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $90ca79fb430b6e09$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $90ca79fb430b6e09$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $90ca79fb430b6e09$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $90ca79fb430b6e09$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $90ca79fb430b6e09$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $90ca79fb430b6e09$export$81124e6148ca5db0[0];
}
function $90ca79fb430b6e09$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[1];
}
function $90ca79fb430b6e09$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[2];
}
function $90ca79fb430b6e09$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[3];
}
function $90ca79fb430b6e09$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $90ca79fb430b6e09$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("6Ctoj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e109bd73548e92fc$export$2e2bcd8739ae039);
let $e109bd73548e92fc$var$debugEnabled = false;
let $e109bd73548e92fc$var$stacktracesEnabled = false;
function $e109bd73548e92fc$export$748ada60eaf985cc(enable) {
    $e109bd73548e92fc$var$debugEnabled = enable;
}
function $e109bd73548e92fc$export$4f7017086af31c25(enable) {
    $e109bd73548e92fc$var$stacktracesEnabled = enable;
}
function $e109bd73548e92fc$export$2a858f450a2f66d() {
    if ($e109bd73548e92fc$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $e109bd73548e92fc$export$2e2bcd8739ae039(msg, ...args) {
    if ($e109bd73548e92fc$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("4kfbr", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $f8976e2813fe24b2$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $f8976e2813fe24b2$export$c724588856bbfbcf);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $f8976e2813fe24b2$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", () => $f8976e2813fe24b2$export$91b2fa6a0fe06408);



var $cqJWb = parcelRequire("cqJWb");
const $f8976e2813fe24b2$var$packageName = "platform-pkg";
const $f8976e2813fe24b2$var$packageVersion = "0.0.0-use.local";
const $f8976e2813fe24b2$export$245097525aef1262 = 'sli';
const $f8976e2813fe24b2$export$c724588856bbfbcf = 'smart';
const $f8976e2813fe24b2$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $cqJWb.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $f8976e2813fe24b2$var$packageName,
                    packageVersion: $f8976e2813fe24b2$var$packageVersion,
                    componentName: (0, $cqJWb.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
const $f8976e2813fe24b2$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            attributes: {
                packageName: $f8976e2813fe24b2$var$packageName,
                packageVersion: $f8976e2813fe24b2$var$packageVersion,
                componentName: (0, $cqJWb.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $cqJWb.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        return event;
    };
const $f8976e2813fe24b2$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $f8976e2813fe24b2$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
const $f8976e2813fe24b2$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
        attributes: {
            packageName: $f8976e2813fe24b2$var$packageName,
            packageVersion: $f8976e2813fe24b2$var$packageVersion,
            componentName: (0, $cqJWb.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $f8976e2813fe24b2$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $cqJWb.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $f8976e2813fe24b2$var$packageName,
                    packageVersion: $f8976e2813fe24b2$var$packageVersion,
                    componentName: (0, $cqJWb.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $f8976e2813fe24b2$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $cqJWb.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

const $094ce2d9636497d7$export$d821aa4c8afb384e = 'fabric-elements';



parcelRegister("8dw1i", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_USER_ID", () => $359ac0149aaccbc2$export$af8124aa496797f2);
$parcel$export(module.exports, "default", () => $359ac0149aaccbc2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $kbF2s = parcelRequire("kbF2s");

var $ab8uA = parcelRequire("ab8uA");

var $k3AGD = parcelRequire("k3AGD");

var $cqJWb = parcelRequire("cqJWb");

var $4kfbr = parcelRequire("4kfbr");

var $cb25w = parcelRequire("cb25w");

var $jZA09 = parcelRequire("jZA09");

var $j6B3T = parcelRequire("j6B3T");

var $bTspB = parcelRequire("bTspB");
const $359ac0149aaccbc2$export$7452d7062a4d0634 = 1000;
const $359ac0149aaccbc2$export$af8124aa496797f2 = '_|unknown|_';
class $359ac0149aaccbc2$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    constructor(props){
        super(props), this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        }, this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $359ac0149aaccbc2$export$7452d7062a4d0634);
        }, this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        }, this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $cqJWb.MentionType).SELF;
            if ((0, $cqJWb.isRestricted)(accessLevel)) return (0, $cqJWb.MentionType).RESTRICTED;
            return (0, $cqJWb.MentionType).DEFAULT;
        };
        (0, $bTspB.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
    componentDidMount() {
        (0, $bTspB.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $bTspB.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $jZA09.UFOExperienceState)['STARTED'],
            (0, $jZA09.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j6B3T.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            },
            children: (message)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: `@${message}`
                })
        });
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$359ac0149aaccbc2$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $cqJWb.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhVLw.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ab8uA.default), {
                mentionType: mentionType,
                onClick: handleOnClick,
                onMouseEnter: handleOnMouseEnter,
                onMouseLeave: handleOnMouseLeave,
                spellCheck: false,
                "data-testid": `mention-${id}`,
                "data-mention-type": mentionType,
                "data-mention-tooltip": showTooltip,
                children: failedMention ? this.renderUnknownUserError(id) : text || '@...'
            })
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bTspB.UfoErrorBoundary), {
            id: id,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: localId,
                "data-mention-id": id,
                "data-local-id": localId,
                "data-access-level": accessLevel,
                spellCheck: false,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kbF2s.default), {
                    children: showTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                        fallback: mentionComponent,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k3AGD.default), {
                            name: text,
                            children: mentionComponent
                        })
                    }) : mentionComponent
                })
            })
        });
    }
}
const $359ac0149aaccbc2$var$MentionWithAnalytics = (0, $cb25w.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $4kfbr.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $4kfbr.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($359ac0149aaccbc2$export$92ab8442e7a15cef);
const $359ac0149aaccbc2$var$Mention = $359ac0149aaccbc2$var$MentionWithAnalytics;
var $359ac0149aaccbc2$export$2e2bcd8739ae039 = $359ac0149aaccbc2$var$Mention;

});
parcelRegister("kbF2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2323b0dd270b712$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $j6B3T = parcelRequire("j6B3T");
const $a2323b0dd270b712$var$EMPTY = {};
const $a2323b0dd270b712$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState($a2323b0dd270b712$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        let aborted = false;
        setMessages($a2323b0dd270b712$var$EMPTY);
        (0, $j6B3T.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $a2323b0dd270b712$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $koVbs.default)();
    const messages = $a2323b0dd270b712$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        ...intl,
        messages: messages,
        children: children
    });
};
var $a2323b0dd270b712$export$2e2bcd8739ae039 = $a2323b0dd270b712$var$MessagesIntlProvider;

});
parcelRegister("j6B3T", function(module, exports) {

$parcel$export(module.exports, "UnknownUserError", () => $2ed9ffbf75c73a6c$export$98e06fe7a6174253);
$parcel$export(module.exports, "NoAccessWarning", () => $2ed9ffbf75c73a6c$export$58bd5a2057b6b855);
$parcel$export(module.exports, "NoAccessLabel", () => $2ed9ffbf75c73a6c$export$da9f8ce14593162f);
$parcel$export(module.exports, "getMessagesForLocale", () => $2ed9ffbf75c73a6c$export$d0a3169680473b6c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8aQI9 = parcelRequire("8aQI9");
const $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $2ed9ffbf75c73a6c$export$98e06fe7a6174253 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).unknownUserError);
const $2ed9ffbf75c73a6c$export$58bd5a2057b6b855 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).noAccessWarning);
const $2ed9ffbf75c73a6c$export$da9f8ce14593162f = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).noAccessLabel);
const $2ed9ffbf75c73a6c$export$4a258ffee7316766 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).defaultHeadline);
const $2ed9ffbf75c73a6c$export$702321a50d74536e = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).defaultAdvisedAction);
const $2ed9ffbf75c73a6c$export$ed7f16088a93ae9d = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).loginAgain);
const $2ed9ffbf75c73a6c$export$3ab158df56460d1c = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).differentText);































const $2ed9ffbf75c73a6c$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("fPyR5")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("d8Ulq")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("7WKiB")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("66Hai")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("1Azr6")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("ceUid")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("imiLL")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("fzYxu")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("50SvZ")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("4KJ3I")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("9n0S7")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("7MkZ1")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("hPCID")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("7Z7ZI")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("cWcD9")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("bRMAA")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("9N4h9")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("dTCxR")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("1vwox")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("7zNXb")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("dvYlT")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("gwSnb")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("8cruq")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("dzC34")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("jMBvi")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("5qCSb")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("5frdN")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("8NaEX")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("hwknJ")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("jomQG")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $2ed9ffbf75c73a6c$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("66Hai")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("8aQI9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6ca607c1e1522de5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $6ca607c1e1522de5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unknownUserError: {
        id: 'fabric.mention.unknow.user.error',
        defaultMessage: 'Unknown user {userId}',
        description: 'Mention user name could not be found or look up failed'
    },
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified"
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon'
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend'
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs'
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs'
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.mentions.team.member.count',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.mentions.team.member.count.including.you',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.mentions.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.mentions.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    xProductMentionDescription: {
        id: 'fabric.elements.mentions.xproduct.mention.description',
        defaultMessage: 'Needs access to Confluence',
        description: 'Description for a x-product mention item in the mention list in Confluence'
    }
});

});

parcelRegister("fPyR5", function(module, exports) {

let $b866a7fabe92dfdc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b866a7fabe92dfdc$var$load("dsDeQ").then(()=>parcelRequire('dTLgY'));

});

parcelRegister("d8Ulq", function(module, exports) {

let $9917ba989184e699$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9917ba989184e699$var$load("6dIE2").then(()=>parcelRequire('keyh3'));

});

parcelRegister("7WKiB", function(module, exports) {

let $5c91dd3a9f26c791$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5c91dd3a9f26c791$var$load("jYcAq").then(()=>parcelRequire('eL3iu'));

});

parcelRegister("66Hai", function(module, exports) {

let $4724c94feda73ad4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4724c94feda73ad4$var$load("6MuqU").then(()=>parcelRequire('wBhQ2'));

});

parcelRegister("1Azr6", function(module, exports) {

let $1284a4216b08215d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1284a4216b08215d$var$load("l8igA").then(()=>parcelRequire('27EyS'));

});

parcelRegister("ceUid", function(module, exports) {

let $8e9275682a4023a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e9275682a4023a5$var$load("cp1kc").then(()=>parcelRequire('eoxiv'));

});

parcelRegister("imiLL", function(module, exports) {

let $d5d8d7467b96ff2a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d5d8d7467b96ff2a$var$load("tBMef").then(()=>parcelRequire('6jEIT'));

});

parcelRegister("fzYxu", function(module, exports) {

let $b57915bd849d4c26$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b57915bd849d4c26$var$load("e4cqm").then(()=>parcelRequire('dkMw7'));

});

parcelRegister("50SvZ", function(module, exports) {

let $3a673d6432a4e3c8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a673d6432a4e3c8$var$load("yHeUA").then(()=>parcelRequire('5NjhV'));

});

parcelRegister("4KJ3I", function(module, exports) {

let $375e69166acd46ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $375e69166acd46ba$var$load("69FtF").then(()=>parcelRequire('bWMX4'));

});

parcelRegister("9n0S7", function(module, exports) {

let $6d26f02f29aa7bc8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d26f02f29aa7bc8$var$load("1SwVQ").then(()=>parcelRequire('aPy43'));

});

parcelRegister("7MkZ1", function(module, exports) {

let $5a9d4aedc93beac3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a9d4aedc93beac3$var$load("iMqxw").then(()=>parcelRequire('6FrOe'));

});

parcelRegister("hPCID", function(module, exports) {

let $cfb53bd938dfab46$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cfb53bd938dfab46$var$load("i9sdu").then(()=>parcelRequire('epfvh'));

});

parcelRegister("7Z7ZI", function(module, exports) {

let $5d046e711e21fea1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d046e711e21fea1$var$load("aydQg").then(()=>parcelRequire('hjvLU'));

});

parcelRegister("cWcD9", function(module, exports) {

let $96b4b2f8299e9753$var$load = (parcelRequire("28QjX"))(4);
module.exports = $96b4b2f8299e9753$var$load("5znUH").then(()=>parcelRequire('dclct'));

});

parcelRegister("bRMAA", function(module, exports) {

let $8a3a55ba62b1ac51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8a3a55ba62b1ac51$var$load("1lvxw").then(()=>parcelRequire('56DDk'));

});

parcelRegister("9N4h9", function(module, exports) {

let $720c01b8e2435912$var$load = (parcelRequire("28QjX"))(4);
module.exports = $720c01b8e2435912$var$load("7yQmI").then(()=>parcelRequire('1Vmnr'));

});

parcelRegister("dTCxR", function(module, exports) {

let $a1de4faf5cb6d125$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1de4faf5cb6d125$var$load("6TpZW").then(()=>parcelRequire('lTYFq'));

});

parcelRegister("1vwox", function(module, exports) {

let $1191d09def236a27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1191d09def236a27$var$load("2eSUb").then(()=>parcelRequire('hxNc0'));

});

parcelRegister("7zNXb", function(module, exports) {

let $58428d06a04c9999$var$load = (parcelRequire("28QjX"))(4);
module.exports = $58428d06a04c9999$var$load("fUluO").then(()=>parcelRequire('h7PMN'));

});

parcelRegister("dvYlT", function(module, exports) {

let $9d6cfc4c4f81da5d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9d6cfc4c4f81da5d$var$load("DchKe").then(()=>parcelRequire('3T3Pt'));

});

parcelRegister("gwSnb", function(module, exports) {

let $c089cfd0d365cdb2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c089cfd0d365cdb2$var$load("eYBMi").then(()=>parcelRequire('jvE81'));

});

parcelRegister("8cruq", function(module, exports) {

let $5f84c4a122f8d1fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f84c4a122f8d1fc$var$load("6q2et").then(()=>parcelRequire('lxjSE'));

});

parcelRegister("dzC34", function(module, exports) {

let $9e1c0ede9f7b180a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9e1c0ede9f7b180a$var$load("iINAq").then(()=>parcelRequire('fIX00'));

});

parcelRegister("jMBvi", function(module, exports) {

let $e66f9780892e0422$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e66f9780892e0422$var$load("ibfKG").then(()=>parcelRequire('kbvg1'));

});

parcelRegister("5qCSb", function(module, exports) {

let $3f3d88cbaf674b39$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3f3d88cbaf674b39$var$load("80oK6").then(()=>parcelRequire('2eUU2'));

});

parcelRegister("5frdN", function(module, exports) {

let $3d237818f4027a7b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3d237818f4027a7b$var$load("9X4yo").then(()=>parcelRequire('kxF7S'));

});

parcelRegister("8NaEX", function(module, exports) {

let $666b2b1ac16e3915$var$load = (parcelRequire("28QjX"))(4);
module.exports = $666b2b1ac16e3915$var$load("hYMIE").then(()=>parcelRequire('aIfZT'));

});

parcelRegister("hwknJ", function(module, exports) {

let $cc153c3a43b299e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc153c3a43b299e0$var$load("cjVNf").then(()=>parcelRequire('lVs4z'));

});

parcelRegister("jomQG", function(module, exports) {

let $e1e1fb78e24836d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e1e1fb78e24836d0$var$load("16rPB").then(()=>parcelRequire('bY3rp'));

});



parcelRegister("ab8uA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6273a4608d138fff$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $cqJWb = parcelRequire("cqJWb");

var $5uXOq = parcelRequire("5uXOq");
const $6273a4608d138fff$var$mentionStyle = {
    [(0, $cqJWb.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
    },
    [(0, $cqJWb.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        text: `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $cqJWb.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
    }
};
const $6273a4608d138fff$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $6273a4608d138fff$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $6273a4608d138fff$var$PrimitiveMention = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)("display:inline;border:1px solid ", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $6273a4608d138fff$export$2e2bcd8739ae039 = $6273a4608d138fff$var$PrimitiveMention;

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("k3AGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4938be5a70d0163$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $e4938be5a70d0163$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("eEwz1")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $e4938be5a70d0163$export$2e2bcd8739ae039 = $e4938be5a70d0163$var$AsyncNoAccessTooltip;

});
parcelRegister("eEwz1", function(module, exports) {

let $aaae0f9a4fd8ce85$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aaae0f9a4fd8ce85$var$load("8n8M3").then(()=>parcelRequire('4YERU'));

});


parcelRegister("bTspB", function(module, exports) {

$parcel$export(module.exports, "mentionRenderedUfoExperience", () => $fb9391c5736559e1$export$1d011e4240507c78);
$parcel$export(module.exports, "UfoErrorBoundary", () => $fb9391c5736559e1$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
const $fb9391c5736559e1$export$1d011e4240507c78 = new (0, $cBycP.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
});
class $fb9391c5736559e1$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        $fb9391c5736559e1$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});
parcelRegister("cBycP", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);

var $dCAsn = parcelRequire("dCAsn");

var $boHLC = parcelRequire("boHLC");
class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $boHLC.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $dCAsn.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});




parcelRegister("b6FQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7d478a209170c68$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kmW28 = parcelRequire("kmW28");

var $37PA3 = parcelRequire("37PA3");
function $b7d478a209170c68$export$2e2bcd8739ae039({ autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, localId: localId }) {
    const { cloudId: cloudId, resourceClient: resourceClient } = profilecardProvider;
    const actions = (0, $5uXOq.useMemo)(()=>profilecardProvider.getActions(id, text, accessLevel), [
        accessLevel,
        id,
        profilecardProvider,
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $37PA3.default), {
        autoFocus: autoFocus,
        cloudId: cloudId,
        userId: id,
        resourceClient: resourceClient,
        actions: actions,
        trigger: "click",
        position: "bottom-end",
        testId: "mention-with-profilecard-trigger",
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        ariaLabel: text.replace(/^@/, ''),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kmW28.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            mentionProvider: mentionProvider,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        })
    });
}

});
parcelRegister("37PA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f0fdc37b33e30ae$export$2e2bcd8739ae039);


var $dYuIx = parcelRequire("dYuIx");

var $264zF = parcelRequire("264zF");
var $1f0fdc37b33e30ae$export$2e2bcd8739ae039 = (0, $264zF.default);

});
parcelRegister("dYuIx", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $78b4a66e55984f2d$export$403d297463f226af);

var $5uXOq = parcelRequire("5uXOq");

const $78b4a66e55984f2d$export$403d297463f226af = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("9jxN3")));

});
parcelRegister("9jxN3", function(module, exports) {

let $6c80196f700d9a25$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6c80196f700d9a25$var$load("h2MrD"),
    $6c80196f700d9a25$var$load("bYT2S"),
    $6c80196f700d9a25$var$load("l3dV9")
]).then(()=>parcelRequire('lrMir'));

});


parcelRegister("264zF", function(module, exports) {

$parcel$export(module.exports, "default", () => $74b3c02273951832$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $adIkV = parcelRequire("adIkV");
var $gH4E9 = parcelRequire("gH4E9");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k5uoT = parcelRequire("k5uoT");

var $4sfdL = parcelRequire("4sfdL");

var $chprS = parcelRequire("chprS");

var $jnj6z = parcelRequire("jnj6z");

var $ivXTE = parcelRequire("ivXTE");


var $kDbj5 = parcelRequire("kDbj5");

var $dYuIx = parcelRequire("dYuIx");

var $ifxzB = parcelRequire("ifxzB");
function $74b3c02273951832$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDbj5.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dYuIx.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $74b3c02273951832$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isMounted = (0, $5uXOq.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $VSDnB.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $e41878b3b8cab0db$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $VSDnB.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $e41878b3b8cab0db$export$89a9f35a94d7f196);
    const showTimer = (0, $5uXOq.useRef)(0);
    const hideTimer = (0, $5uXOq.useRef)(0);
    const [visible, setVisible] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
    const [hasError, setHasError] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $5uXOq.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $5uXOq.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $5uXOq.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $5uXOq.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const triggerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $5uXOq.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $5uXOq.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $5uXOq.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $5uXOq.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $VSDnB.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $5uXOq.useCallback)(()=>{
        return (0, $4sfdL.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)($74b3c02273951832$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $2OMIu.jsx)($74b3c02273951832$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $chprS.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        children: children
                    });
                },
                zIndex: (0, $k5uoT.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $VSDnB.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adIkV.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $gH4E9.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $74b3c02273951832$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnj6z.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ifxzB.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("adIkV", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $c3877992df568d20$export$93fe397a02fe8b76);

var $5uXOq = parcelRequire("5uXOq");

const $c3877992df568d20$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("7rsnG")));

});
parcelRegister("7rsnG", function(module, exports) {

let $56b111e3894d3389$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $56b111e3894d3389$var$load("cM9em"),
    $56b111e3894d3389$var$load("fr9NE"),
    $56b111e3894d3389$var$load("h2MrD"),
    $56b111e3894d3389$var$load("bYT2S"),
    $56b111e3894d3389$var$load("HRhLG")
]).then(()=>parcelRequire('iRLc5'));

});


parcelRegister("gH4E9", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $b9e3bff5640b4187$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $b9e3bff5640b4187$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $b9e3bff5640b4187$export$7a1fc1a1b0477464);
var $b9e3bff5640b4187$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    return KudosType;
}({});
var $b9e3bff5640b4187$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $b9e3bff5640b4187$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($b9e3bff5640b4187$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("4sfdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1251cd76451c32$export$2e2bcd8739ae039);
const $ea1251cd76451c32$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $ea1251cd76451c32$export$2e2bcd8739ae039 = $ea1251cd76451c32$var$filterActions;

});

parcelRegister("chprS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b051cf4c3ebf799$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4b051cf4c3ebf799$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($4b051cf4c3ebf799$var$messages.label, {
        fullName: fullName
    }) : formatMessage($4b051cf4c3ebf799$var$messages.fallbackLabel);
};
const $4b051cf4c3ebf799$var$messages = (0, $7VHMR.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $4b051cf4c3ebf799$export$2e2bcd8739ae039 = $4b051cf4c3ebf799$var$getLabelMessage;

});

parcelRegister("jnj6z", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $a03faa2abdc74ae6$export$6aa22a823032b784);
$parcel$export(module.exports, "ProfileImage", () => $a03faa2abdc74ae6$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $a03faa2abdc74ae6$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $a03faa2abdc74ae6$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $a03faa2abdc74ae6$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $a03faa2abdc74ae6$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $a03faa2abdc74ae6$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $a03faa2abdc74ae6$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $a03faa2abdc74ae6$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $a03faa2abdc74ae6$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $a03faa2abdc74ae6$export$2062e7265a95a823);
$parcel$export(module.exports, "LozengeWrapper", () => $a03faa2abdc74ae6$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $a03faa2abdc74ae6$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $a03faa2abdc74ae6$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $a03faa2abdc74ae6$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "SpinnerContainer", () => $a03faa2abdc74ae6$export$a5e06607a5ac6158);
$parcel$export(module.exports, "CardContainer", () => $a03faa2abdc74ae6$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $a03faa2abdc74ae6$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $a03faa2abdc74ae6$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $a03faa2abdc74ae6$export$b0ec2c767a0e0eab);
/* Card.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");


var $k5uoT = parcelRequire("k5uoT");

var $huHkE = parcelRequire("huHkE");

var $bWGt6 = parcelRequire("bWGt6");
function $a03faa2abdc74ae6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a03faa2abdc74ae6$var$kudosButtonAnimationTransformationCompiled = null;
const $a03faa2abdc74ae6$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    profileImage: "_kqswstnw _154i1ejb _1ltv1ejb",
    actionsFlexSpacer: "_16jlkb7n _1o9zidpf _i0dl1wug",
    kudosBlobAnimationStyle: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _154ixy5q",
    animationWrapper: "_mkrz1rip _kqswstnw _154ize3t _1ltvze3t _94n5ze3t _1xi2ze3t",
    animatedKudosButton: "_18u0u2gc",
    actionButtonGroup: "_zulp12x7 _uiztglyw _19pkpxbi _2hwxze3t _18u0ze3t _otyrze3t _y3gnusic _1bahesu3 _1e0c1txw",
    overflowActionButtonsWrapper: "_1e0c1o8l _1bsbzwfg _4t3izwfg",
    cardContent: "_1e0c1txw _2lx21bp4 _1tkebv7e",
    detailsGroup: "_1e0c1txw _2lx21bp4 _18u01epz _19bvxy5q _1bsb18pt",
    disabledInfo: "_11c81o8v _syaz1fxt _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t",
    lozengeWrapper: "_19pkpxbi _1e0c1ule",
    customLozengeContainer: "_1e0c1txw _2lx2vrvc _1n261g80 _1bah1y6m _19pkutpp",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm",
    cardContainer: "_1reo15vq _18m915vq _kqswh2mm _12vemgnk _1lrw14bs _ca0q1ejb _19bv1ejb _u5f31ejb _n3td1ejb",
    cardContainerActiveUser: "_1itk1419",
    cardContainerDisabledUser: "_1itkkf3t",
    cardContainerWithElevation: "_2rkoglpi _16qs1cd0",
    detailsLabel: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1y6m _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t _o5721q9c",
    detailsLabelExtraTopSpace: "_19pkxy5q",
    detailsLabelIcon: "_1e0c1txw _1o9zidpf _syaz131l _1bsb7vkz _4t3i7vkz _s7n4jp4b _19pkze3t",
    detailsLabelText: "_1reo15vq _18m915vq _11c8dcr7 _1bto1l2s _syaz1fxt _19pkze3t _18u0ze3t",
    kudosBlobAnimation: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _j7hq1q51 _tip8kb7n _5sagi11n _1itkiwwe",
    jobTitleLabel: "_19pkze3t _otyrze3t _18u0utpp _2hwxze3t",
    appTitleLabel: "_2rkoglpi _syaz1fxt _u5f312x7 _19bv12x7 _1bsb1ns9 _19pk1b66 _otyrze3t _18u0utpp _2hwxze3t"
};
const $a03faa2abdc74ae6$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CardWrapperLegacy, {
        "data-testid": testId,
        role: role,
        "aria-labelledby": labelledBy,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CardWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo19"
})("background-color:", (0, $huHkE.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:360px;");
const $a03faa2abdc74ae6$export$a7a74ab5cffd1455 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.profileImage),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$ProfileImageLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$ProfileImageLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo18"
})({
    name: "eukccz",
    styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
});
const $a03faa2abdc74ae6$export$d395c8d16f1e359d = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.actionsFlexSpacer)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$ActionsFlexSpacerLegacy, {}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$ActionsFlexSpacerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo17"
})({
    name: "18pny36",
    styles: "flex:1 0 auto"
}); // eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
const $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation = (0, $f8Sb3.keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
const $a03faa2abdc74ae6$export$b08abf2f97b92ea5 = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.kudosBlobAnimationStyle)
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$KudosBlobAnimationStyleLegacy, {
        className: "kudos-blob-animation"
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a03faa2abdc74ae6$var$KudosBlobAnimationStyleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo16"
})("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", 32 / 14, "em;animation-name:", $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
const $a03faa2abdc74ae6$export$4a8a956251d4bf6f = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.kudosBlobAnimationStyle)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$KudosBlobAnimationLegacy, {});
const $a03faa2abdc74ae6$var$KudosBlobAnimationLegacy = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$export$b08abf2f97b92ea5, {});
const $a03faa2abdc74ae6$export$58517bb1b373a54c = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.animationWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$AnimationWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$AnimationWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo15"
})("clip-path:inset(0px 0px 0px 0px round ", (0, $k5uoT.borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
const $a03faa2abdc74ae6$export$6196a3f52a6944fe = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.animatedKudosButton),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$AnimatedKudosButtonLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$AnimatedKudosButtonLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo14"
})({
    name: "18xp5qc",
    styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
});
const $a03faa2abdc74ae6$export$73d695ae27330056 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.actionButtonGroup),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$ActionButtonGroupLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$ActionButtonGroupLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo13"
})("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $a03faa2abdc74ae6$export$ff778e5b796745a6 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.overflowActionButtonsWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$OverflowActionButtonsWrapperLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$OverflowActionButtonsWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo12"
})("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $a03faa2abdc74ae6$export$64ef9b8c11710c47 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.cardContent),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CardContentLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CardContentLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo11"
})({
    name: "1jc6z0y",
    styles: "display:flex;flex-direction:column;min-height:136px"
});
const $a03faa2abdc74ae6$export$35cf684daac137ac = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsGroup),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsGroupLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsGroupLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo10"
})({
    name: "c8pdei",
    styles: "display:flex;flex-direction:column;margin-left:116px;width:196px"
});
const $a03faa2abdc74ae6$export$2062e7265a95a823 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.disabledInfo),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DisabledInfoLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DisabledInfoLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo9"
})("font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $huHkE.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
const $a03faa2abdc74ae6$export$75180efdd3f4d9c2 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.lozengeWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$LozengeWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$LozengeWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo8"
})({
    name: "m760b1",
    styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
});
const $a03faa2abdc74ae6$export$6ebf103500ba5a45 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.customLozengeContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CustomLozengeContainerLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CustomLozengeContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)($a03faa2abdc74ae6$export$75180efdd3f4d9c2, {
    target: "e1ebb2vo7"
})({
    name: "15oqcei",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
});
const $a03faa2abdc74ae6$export$d6c0e5f211c8d617 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.jobTitleLabel),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            maxLines: 1,
            color: "color.text.inverse",
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$JobTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$JobTitleLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1ebb2vo6"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $huHkE.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;");
const $a03faa2abdc74ae6$export$4865ffa72a4d5f9 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.appTitleLabel),
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            color: "color.text",
            size: "UNSAFE_small",
            weight: "bold",
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$AppTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$AppTitleLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1ebb2vo5"
})("background:", (0, $huHkE.appLabelBgColor), ";color:", (0, $huHkE.appLabelTextColor), ";border-radius:", (0, $k5uoT.borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:var(--ds-font-weight-bold, 700);text-transform:uppercase;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;");
const $a03faa2abdc74ae6$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.spinnerContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$SpinnerContainerLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$SpinnerContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo4"
})({
    name: "1e8m6rx",
    styles: "align-items:center;display:flex;height:96px;justify-content:center;position:relative"
});
const $a03faa2abdc74ae6$export$8a23e74e5cf3ca41 = ({ children: children, isDisabledUser: isDisabledUser, withoutElevation: withoutElevation })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.cardContainer, isDisabledUser ? $a03faa2abdc74ae6$var$styles.cardContainerDisabledUser : $a03faa2abdc74ae6$var$styles.cardContainerActiveUser, !withoutElevation && $a03faa2abdc74ae6$var$styles.cardContainerWithElevation),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CardContainerLegacy, {
        isDisabledUser: isDisabledUser,
        withoutElevation: withoutElevation,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CardContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo3"
})("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% 96px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $829f609a65d26a98$export$7d3359664e8bb0e5}, 0 0 1px ${0, $829f609a65d26a98$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, $k5uoT.borderRadius)()}px`, ";overflow:hidden;");
const $a03faa2abdc74ae6$export$138a08882ebf7289 = ({ children: children, extraTopSpace: extraTopSpace = false })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsLabel, extraTopSpace && $a03faa2abdc74ae6$var$styles.detailsLabelExtraTopSpace),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo2"
})({
    name: "vjwven",
    styles: "display:flex;align-items:center;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}"
});
const $a03faa2abdc74ae6$export$79d7d9b2f6a70c70 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "dt",
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsLabelIcon),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsLabelIconLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsLabelIconLegacy = /*#__PURE__*/ (0, $bWGt6.default)("dt", {
    target: "e1ebb2vo1"
})("display:flex;flex-shrink:0;color:", (0, $huHkE.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
const $a03faa2abdc74ae6$export$b0ec2c767a0e0eab = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "dd",
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsLabelText),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsLabelTextLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsLabelTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("dd", {
    target: "e1ebb2vo0"
})("overflow:hidden;text-overflow:ellipsis;color:", (0, $huHkE.labelTextColor), ";font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-050, 4px);padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");

});
parcelRegister("huHkE", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $61d9a2704bf54ca1$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $61d9a2704bf54ca1$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $61d9a2704bf54ca1$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $61d9a2704bf54ca1$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $61d9a2704bf54ca1$export$5c2df128da90e8de);
$parcel$export(module.exports, "appLabelBgColor", () => $61d9a2704bf54ca1$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $61d9a2704bf54ca1$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $61d9a2704bf54ca1$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $61d9a2704bf54ca1$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $61d9a2704bf54ca1$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $61d9a2704bf54ca1$export$be3c814f7ed506ed);

const $61d9a2704bf54ca1$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $61d9a2704bf54ca1$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`;
const $61d9a2704bf54ca1$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`;
const $61d9a2704bf54ca1$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
const $61d9a2704bf54ca1$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $61d9a2704bf54ca1$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
const $61d9a2704bf54ca1$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
const $61d9a2704bf54ca1$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`;
const $61d9a2704bf54ca1$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
const $61d9a2704bf54ca1$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;

});


parcelRegister("ivXTE", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $533bc31bb6af10e0$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $533bc31bb6af10e0$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $533bc31bb6af10e0$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $533bc31bb6af10e0$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $533bc31bb6af10e0$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $533bc31bb6af10e0$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $533bc31bb6af10e0$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $533bc31bb6af10e0$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $533bc31bb6af10e0$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $533bc31bb6af10e0$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $533bc31bb6af10e0$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $533bc31bb6af10e0$export$a9f8c9f412cf5664);

var $6TKEY = parcelRequire("6TKEY");
/** Below lines are copied from teams common analytics */ const $533bc31bb6af10e0$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $533bc31bb6af10e0$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $533bc31bb6af10e0$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $533bc31bb6af10e0$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($533bc31bb6af10e0$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $533bc31bb6af10e0$var$TEAM_SUBJECT = 'teamProfileCard';
const $533bc31bb6af10e0$var$USER_SUBJECT = 'profilecard';
const $533bc31bb6af10e0$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $533bc31bb6af10e0$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $6TKEY.getPageTime)())
        }
    });
const $533bc31bb6af10e0$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $533bc31bb6af10e0$var$USER_SUBJECT;
        case 'team':
            return $533bc31bb6af10e0$var$TEAM_SUBJECT;
        case 'agent':
            return $533bc31bb6af10e0$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $533bc31bb6af10e0$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $533bc31bb6af10e0$var$createEvent('ui', 'triggered', $533bc31bb6af10e0$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $533bc31bb6af10e0$export$c9b0e37b229a297b = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$TEAM_SUBJECT, 'request', attributes);
const $533bc31bb6af10e0$export$12dae48763368ac9 = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$USER_SUBJECT, 'request', attributes);
const $533bc31bb6af10e0$export$41816a317479160b = (type, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'rendered', $533bc31bb6af10e0$var$getActionSubject(type), actionSubjectId, attributes);
const $533bc31bb6af10e0$export$fdcd134fbeb1f921 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'action', attributes);
const $533bc31bb6af10e0$export$93260987012593be = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$USER_SUBJECT, 'reportingLines', attributes);
const $533bc31bb6af10e0$export$79befd155063a6a7 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'moreActions', attributes);
const $533bc31bb6af10e0$export$2703289b35687fde = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'avatar', attributes);
const $533bc31bb6af10e0$export$b4411a7661cf2d3f = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $533bc31bb6af10e0$export$c86679da702d560e = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $533bc31bb6af10e0$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("6TKEY", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $83ec369559ddc36d$export$e9faea7c41053334);
const $83ec369559ddc36d$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $83ec369559ddc36d$var$performanceAvailable = $83ec369559ddc36d$var$isPerformanceAvailable();
const $83ec369559ddc36d$var$initialPageTime = Date.now();
const $83ec369559ddc36d$export$e9faea7c41053334 = ()=>{
    if ($83ec369559ddc36d$var$performanceAvailable) return performance.now();
    return Date.now() - $83ec369559ddc36d$var$initialPageTime;
};

});


const $e41878b3b8cab0db$export$5b956b542f1bc1b3 = 800;
const $e41878b3b8cab0db$export$89a9f35a94d7f196 = 200;

parcelRegister("kDbj5", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $9f87d208f89c63eb$export$4b013ffffcb40af8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $ivXTE = parcelRequire("ivXTE");

var $dG58U = parcelRequire("dG58U");

var $cI0Td = parcelRequire("cI0Td");

var $a3FJs = parcelRequire("a3FJs");

var $iwWWV = parcelRequire("iwWWV");
const $9f87d208f89c63eb$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dG58U.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $5uXOq.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a3FJs.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cI0Td.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwWWV.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("dG58U", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $dd4eeae2be471029$export$3761e66a04602cbd);
const $dd4eeae2be471029$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $dd4eeae2be471029$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($dd4eeae2be471029$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("cI0Td", function(module, exports) {

$parcel$export(module.exports, "default", () => $f71e8c5b4eb5da96$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $hI6SY = parcelRequire("hI6SY");

var $d5Zn3 = parcelRequire("d5Zn3");

var $VSDnB = parcelRequire("VSDnB");

var $cgL5K = parcelRequire("cgL5K");

var $2uTKk = parcelRequire("2uTKk");

var $ivXTE = parcelRequire("ivXTE");
const $f71e8c5b4eb5da96$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2uTKk.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2uTKk.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2uTKk.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hI6SY))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d5Zn3))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && ((0, $VSDnB.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                onClick: reload,
                children: "Try again"
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                appearance: "link",
                onClick: reload,
                children: "Try again"
            }))
        ]
    });
};
var $f71e8c5b4eb5da96$export$2e2bcd8739ae039 = $f71e8c5b4eb5da96$var$ErrorMessage;

});
parcelRegister("2uTKk", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $0619b202cbb0de2c$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $0619b202cbb0de2c$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $0619b202cbb0de2c$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $huHkE = parcelRequire("huHkE");

var $bWGt6 = parcelRequire("bWGt6");
const $0619b202cbb0de2c$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $0619b202cbb0de2c$export$bb27b7e39840238f = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.errorWrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$ErrorWrapperLegacy, {
        "data-testId": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$ErrorWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1gaqn292"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $huHkE.errorIconColor)
});
const $0619b202cbb0de2c$export$b065fd053267ec81 = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.errorTitle),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$ErrorTitleLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$ErrorTitleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn291"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $huHkE.errorTitleColor),
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $0619b202cbb0de2c$export$90d92ccfb27352c6 = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.teamErrorText),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$TeamErrorTextLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$TeamErrorTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn290"
})({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});


parcelRegister("a3FJs", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $642b3278878bc39a$export$2c6604b50c274e6f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $642b3278878bc39a$var$styles = (0, $8CUq3.xcss)({
    width: '360px'
});
const $642b3278878bc39a$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $642b3278878bc39a$var$styles,
        children: children
    });
};

});

parcelRegister("iwWWV", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $b487397875f853f0$export$ed0ca9c1d49ea0bf);

var $5uXOq = parcelRequire("5uXOq");

const $b487397875f853f0$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2K454")));

});
parcelRegister("2K454", function(module, exports) {

let $1ff30b051f5792f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1ff30b051f5792f2$var$load("cM9em"),
    $1ff30b051f5792f2$var$load("fr9NE"),
    $1ff30b051f5792f2$var$load("h2MrD"),
    $1ff30b051f5792f2$var$load("bYT2S"),
    $1ff30b051f5792f2$var$load("cLGTI")
]).then(()=>parcelRequire('9gV7o'));

});



parcelRegister("ifxzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $44786ae639641a68$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $jnj6z = parcelRequire("jnj6z");

var $ivXTE = parcelRequire("ivXTE");
const $44786ae639641a68$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnj6z.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
    });
};
var $44786ae639641a68$export$2e2bcd8739ae039 = $44786ae639641a68$var$UserLoadingState;

});






parcelRegister("l4haf", function(module, exports) {

$parcel$export(module.exports, "useInlineAnnotationProps", () => $d0388e6a4f35db6c$export$11564cda945bb3c9);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $iYAgE = parcelRequire("iYAgE");

var $2EsbE = parcelRequire("2EsbE");
function $d0388e6a4f35db6c$export$11564cda945bb3c9(props) {
    const draftPositionOld = (0, $5uXOq.useContext)((0, $iYAgE.AnnotationsDraftContext));
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $2EsbE.useAnnotationRangeState)();
    const draftPosition = (0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix') ? selectionDraftDocumentPosition : draftPositionOld;
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}

});



//# sourceMappingURL=mention.8beb74d7.js.map
